import { i18n } from 'next-i18next';

const t = (key: string, variables?: Record<string, any>) => {
  if (!i18n) {
    throw new Error('i18n is not initialized');
  }

  return i18n.t(key, variables);
};

export default t;
